import React from 'react';
import PropTypes from 'prop-types';

import getValidColor from '../../lib/get-valid-color';
import {
  backgroundColorPicker,
  stringSelectSpec,
  boolCheckboxSpec,
} from '../../lib/editing-configs';

import './divider.less';

const Divider = ({ borderColor, borderWidth, fullWidthMobile }) => {
  const dividerClassName = fullWidthMobile
    ? 'standard-divider__cont--100'
    : 'standard-divider__cont';

  return (
    <div className={`${dividerClassName}`}>
      <div
        className="standard-divider"
        style={{
          borderTop: `${borderWidth} solid ${getValidColor(borderColor)}`,
        }}
      />
    </div>
  );
};

Divider.propTypes = {
  borderColor: PropTypes.string,
  borderWidth: PropTypes.string,
  fullWidthMobile: PropTypes.bool,
};

Divider.defaultProps = {
  borderColor: 'charcoal',
  borderWidth: '1',
  fullWidthMobile: false,
};

Divider.getEditingConfig = () => [
  {
    ...backgroundColorPicker,
    fieldName: 'borderColor',
    fieldLabel: 'Color',
  },
  stringSelectSpec(
    'borderWidth',
    'Height of divider (in pixels)',
    [
      { label: '1px', value: '1px' },
      { label: '2px', value: '2px' },
      { label: '3px', value: '3px' },
      { label: '4px', value: '4px' },
    ],
    {
      help: 'Select a divider height between 1px and 4px',
    }
  ),
  boolCheckboxSpec('fullWidthMobile', '100% width in mobile viewports?', {
    help:
      'The Divider defaults to a width of 280px on mobile viewports. Check this box to make it 100% width for mobile viewports instead.',
  }),
];

Divider.displayName = 'Divider';

export default Divider;
